import { ButtonColor } from "@/common/enum/button-color";
import { formatDateToYYYYMMDD, isWithinOneWeek } from "@/common/util/date-util";
import { StatusButton } from "@/components/button/StatusButton";
import { Body14Regular } from "@/components/typography/Body14Regular";
import { Body14Underline } from "@/components/typography/Body14Underline";
import { NoticeDetailDto } from "@/types/dto/notice-detail-dto";
import { Table } from "flowbite-react";
import { CustomCell } from "../CustomCell";

interface Props {
  data: NoticeDetailDto;
  index: number;
  selectedNotice: NoticeDetailDto | undefined;
  handleNoticeNameClick: (id: number) => void;
}

export const PartnerNoticeRow: React.FC<Props> = ({
  data,
  index,
  selectedNotice,
  handleNoticeNameClick,
}) => {
  const isNew = isWithinOneWeek(new Date(data.createdAt));

  return (
    <Table.Row
      key={data.id}
      className={
        selectedNotice?.id === data.id ? "bg-grayscale-contrast-2" : "bg-white"
      }
    >
      <Table.Cell>
        <CustomCell>
          <Body14Regular className="text-semantic-text-body">
            {index}
          </Body14Regular>
        </CustomCell>
      </Table.Cell>
      <Table.Cell
        className="flex"
        onClick={() => handleNoticeNameClick(data.id)}
      >
        <CustomCell>
          {isNew && <StatusButton color={ButtonColor.GREEN}>신규</StatusButton>}
          <Body14Underline className="text-semantic-text-body ml-[8px]">
            {data.title}
          </Body14Underline>
        </CustomCell>
      </Table.Cell>
      <Table.Cell>
        <CustomCell>
          <Body14Regular className="text-semantic-text-body">
            {formatDateToYYYYMMDD(data.createdAt)}
          </Body14Regular>
        </CustomCell>
      </Table.Cell>
    </Table.Row>
  );
};
